import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/components/common/messageservice';
import { Response } from '@angular/http';
import { Postcode } from '../../models/postcode';
import { PostcodesService } from '../services/postcodes.service';
import { Paginated } from '../../models/paginated';

@Component({
	selector: 'app-open-postcodes',
	templateUrl: './open-postcodes.component.html',
	styleUrls: ['./open-postcodes.component.css']
})
export class OpenPostcodesComponent implements OnInit {

	private route: ActivatedRoute;
	private router: Router;
	private postcodesService: PostcodesService;
	private messagesService: MessageService;

	public limit: number;
	public postcodes: Paginated<Postcode[]>;

	constructor(route: ActivatedRoute,
	            router: Router,
	            messagesService: MessageService,
	            postcodesService: PostcodesService) {
		this.route = route;
		this.messagesService = messagesService;
		this.postcodesService = postcodesService;
		this.router = router;

		this.limit = 50;
		this.postcodes = new Paginated<Postcode[]>();
	}

	ngOnInit() {
		if (this.route.snapshot.data['postcodes'] instanceof Object && !(this.route.snapshot.data['distributors'] instanceof Response)) {
			// Postcodes were received.
			this.postcodes = this.route.snapshot.data['postcodes'] as Paginated<Postcode[]>;
		} else {
			// We got a unhandled exception, let's show a message.
			this.messagesService.add({
				severity: 'error',
				summary: 'Fout',
				detail: 'Er is een fout opgetreden tijdens het ophalen van de niet toegewezen postcodes.'
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/postcodes/open-postcodes/open-postcodes.component.ts